import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "sections", "section", "article", "noResults"]

  connect() {
    // Focus search on "/" key
    document.addEventListener("keydown", this.handleKeydown.bind(this))
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown.bind(this))
  }

  handleKeydown(event) {
    if (event.key === "/" && !this.isInputFocused()) {
      event.preventDefault()
      this.inputTarget.focus()
    }
  }

  isInputFocused() {
    const active = document.activeElement
    return active.tagName === "INPUT" || active.tagName === "TEXTAREA"
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    if (query === "") {
      this.showAll()
      return
    }

    let hasVisibleArticles = false

    this.articleTargets.forEach(article => {
      const title = article.dataset.title || ""
      const description = article.dataset.description || ""
      const matches = title.includes(query) || description.includes(query)

      article.classList.toggle("hidden", !matches)
      if (matches) hasVisibleArticles = true
    })

    // Show/hide sections based on visible articles
    this.sectionTargets.forEach(section => {
      const visibleArticles = section.querySelectorAll('[data-docs-search-target="article"]:not(.hidden)')
      section.classList.toggle("hidden", visibleArticles.length === 0)
    })

    // Show no results message
    this.noResultsTarget.classList.toggle("hidden", hasVisibleArticles)
    this.sectionsTarget.classList.toggle("hidden", !hasVisibleArticles)
  }

  showAll() {
    this.articleTargets.forEach(article => article.classList.remove("hidden"))
    this.sectionTargets.forEach(section => section.classList.remove("hidden"))
    this.noResultsTarget.classList.add("hidden")
    this.sectionsTarget.classList.remove("hidden")
  }
}
